import { render, staticRenderFns } from "./FeatureMain2.vue?vue&type=template&id=2308b82c&scoped=true&"
import script from "./FeatureMain2.vue?vue&type=script&lang=js&"
export * from "./FeatureMain2.vue?vue&type=script&lang=js&"
import style0 from "./FeatureMain2.vue?vue&type=style&index=0&id=2308b82c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2308b82c",
  null
  
)

export default component.exports